import { logWrapper } from '../../utils';
import { UAParser } from 'ua-parser-js';

export default {
  extensionInstallService: [
    'runtimeConstant',
    '$q',
    'webApiSettings',
    function (runtimeConstant, $q, webApiSettings) {
      'use strict';
      let factory = {};

      function versionAgeInDays(v) {
        var now = new Date();
        var vc = v.split('.');
        var vdate = new Date(
          2000 + parseInt(vc[0]),
          parseInt(vc[1]) - 1,
          parseInt(vc[2])
        );
        var age = Math.floor(
          Math.abs((now.getTime() - vdate.getTime()) / (24 * 60 * 60 * 1000))
        );
        return age;
      }

      function getNonce(l) {
        if (l === undefined) l = 24;

        var val = '';
        var hex =
          'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVXYZ';

        for (var i = 0; i < l; i++) {
          val += hex.charAt(Math.floor(Math.random() * hex.length));
        }
        return val;
      }

      function processMessage(m) {
        var reply = m.data;
        if (reply.extension) {
          if (reply.id) {
            if (reply.id in factory.id2promise) {
              if (reply.result === 'ok' && !reply.error) {
                factory.id2promise[reply.id].resolve(reply);
              } else {
                factory.id2promise[reply.id].reject(new Error(reply.result));
              }
              delete factory.id2promise[reply.id];
            }
          }
        }
      }

      function msg2promise(msg) {
        return new Promise(function (resolve, reject) {
          msg['id'] = factory.getNonce();
          msg['hwcrypto'] = true;
          window.postMessage(msg, '*');
          factory.id2promise[msg.id] = {
            resolve: resolve,
            reject: reject,
          };
        });
      }

      function hasExtension() {
        var v = factory.msg2promise({});
        var t = new Promise(function (resolve, reject) {
          setTimeout(reject, 1300, 'timeout');
        });
        return Promise.race([v, t]).then(function (r) {
          return r.extension;
        });
      }

      function getNativeVersion() {
        var v = factory.msg2promise({
          type: 'VERSION',
        });

        var t = new Promise(function (resolve, reject) {
          setTimeout(reject, 1300, 'timeout');
        });
        return Promise.race([v, t]).then(function (r) {
          return r.version;
        });
      }

      function getCertificate() {
        var v = factory.msg2promise({ type: 'CERT' });

        var t = new Promise(function (resolve, reject) {
          setTimeout(reject, 360000, { message: 'no_implementation' });
        });

        return Promise.race([v, t]).then(function (r) {
          return r.cert;
        });
      }

      function sign(cert, hash) {
        var v = factory.msg2promise({
          type: 'SIGN',
          cert: cert,
          hash: hash,
        });

        var t = new Promise(function (resolve, reject) {
          setTimeout(reject, 360000, { message: 'no_implementation' });
        });

        return Promise.race([v, t]).then(function (r) {
          return r.signature;
        });
      }

      function firefoxInstall() {
        var deferred = $q.defer();

        var ffversion = factory.updater.latestFirefoxUpdateVersion(
          factory.ffupdate
        );
        var updateurl = webApiSettings.apiServiceBaseUri + 'extension';
        var params = {
          'Web eID': updateurl,
        };
        // eslint-disable-next-line no-console
        console.log(
          'Installing Firefox Extension version ' +
            ffversion +
            ' from ' +
            updateurl
        );
        InstallTrigger.install(params, function () {
          deferred.resolve();
        });

        return deferred.promise;
      }

      function getInstallerURL(p, v, unsigned) {
        var base = 'https://updates.web-eid.com/';
        var host = window.location.origin;
        var digitaldoc = host + '/signer/Digitaldoc.Sign.Native-1.0.1.exe';
        var sign = '';
        if (unsigned) {
          base =
            'https://github.com/hwcrypto/hwcrypto-native/releases/download/';
          sign = '-unsigned';
        }

        if (p.getOS().name === 'Mac OS')
          return base + v + '/Web-eID_' + v + sign + '.pkg';
        if (p.getOS().name === 'Windows') return digitaldoc;
        return null;
      }

      function validateAndInstall(parser, useBeta) {
        var deferred = $q.defer();
        if (parser === undefined) parser = new UAParser();
        var b = parser.getBrowser();
        var p = parser.getOS();

        if (
          ['Mac OS', 'Windows', 'Linux', 'Debian', 'Ubuntu', 'Fedora'].indexOf(
            p.name
          ) === -1
        )
          deferred.reject('noplatform');
        if (['Chrome', 'Firefox', 'Opera', 'Vivaldi'].indexOf(b.name) === -1)
          deferred.reject('nobrowser');
        if (b.name === 'Firefox' && b.major < 52)
          deferred.reject('browserversion');

        factory
          .hasExtension()
          .then(function () {
            factory
              .getNativeVersion()
              .then(function (v) {
                var v2 = useBeta ? factory.beta.native : factory.latest.native;
                if (factory.updater.newerVersion(v, v2)) {
                  var d = {};
                  if (useBeta === true) {
                    d.url = factory.getInstallerURL(
                      parser,
                      factory.beta.native,
                      true
                    );
                    d.newversion = factory.beta.native;
                  } else {
                    d.url = factory.getInstallerURL(
                      parser,
                      factory.latest.native
                    );
                    d.newversion = factory.latest.native;
                  }
                  d.oldversion = v;

                  // eslint-disable-next-line no-console
                  console.log('Update available from ' + v + ' to ' + v2);

                  deferred.reject({
                    error: 'native update required',
                    downloadInfo: d,
                  });
                }
                deferred.resolve();
              })
              .catch(function (e) {
                // eslint-disable-next-line no-console
                console.log(
                  'Could not get native version: ' + JSON.stringify(e)
                );

                var d = {};

                if (useBeta === true) {
                  d.url = factory.getInstallerURL(
                    parser,
                    factory.beta.native,
                    true
                  );
                  d.version = factory.beta.native;
                } else {
                  d.url = factory.getInstallerURL(
                    parser,
                    factory.latest.native
                  );
                  d.version = factory.latest.native;
                }

                deferred.reject({
                  error: 'native not installed',
                  downloadInfo: d,
                });
              });
          })
          .catch(function (e) {
            var d = {};

            if (useBeta === true) {
              d.url = factory.getInstallerURL(
                parser,
                factory.beta.native,
                true
              );
              d.version = factory.beta.native;
            } else {
              d.url = factory.getInstallerURL(parser, factory.latest.native);
              d.version = factory.latest.native;
            }
            if (e === 'timeout') {
              deferred.reject({
                error: 'getextension',
                downloadInfo: d,
              });
            }
            deferred.reject('native_installer');
          });
        return deferred.promise;
      }

      function updaterTodayVersion() {
        var now = new Date();
        return [
          now.getFullYear() - 2000,
          now.getMonth() + 1,
          now.getDate(),
        ].join('.');
      }

      function updaterVersionAgeInDays(from, to) {
        // Default to today
        var now = new Date();
        if (typeof to !== 'undefined') {
          var lc = to.split('.');
          now = new Date(
            2000 + parseInt(lc[0]),
            parseInt(lc[1]) - 1,
            parseInt(lc[2])
          );
        }
        var vc = from.split('.');
        var vdate = new Date(
          2000 + parseInt(vc[0]),
          parseInt(vc[1]) - 1,
          parseInt(vc[2])
        );
        var age = Math.floor(
          (now.getTime() - vdate.getTime()) / (24 * 60 * 60 * 1000)
        );
        return age;
      }

      function updaterNewerVersion(a, b) {
        if (!a) return true;

        if (!b) throw new Error('No version to compare to!');

        var current = a.split('.');
        var other = b.split('.');

        for (var i = 0; i < Math.min(current.length, other.length); i++) {
          var o = parseInt(other[i]);
          var c = parseInt(current[i]);
          if (c === o) continue;
          return o > c;
        }

        if (other.length > current.length) return true;
        return false;
      }

      function updaterLatestFirefoxUpdateVersion(json) {
        var firefox = null;
        json.addons['signer@digitaldoc.com.br']['updates'].forEach(
          function (e) {
            if (factory.updater.newerVersion(firefox, e.version)) {
              firefox = e.version;
            }
          }
        );
        return firefox;
      }

      function run() {
        try {
          factory = {
            latest: {
              extension: '17.3.19',
              native: '17.3.19',
              timestamp: '2017-03-15T18:25:58.178Z',
            },
            ffupdate: {
              addons: {
                'signer@digitaldoc.com.br': {
                  updates: [
                    {
                      version: '17.3.17',
                      update_link:
                        'https://nosso.digitaldoc.com.br/extensions/firefox/digitaldoc_websign-17.3.17-an-fx-windows.xpi',
                    },
                    {
                      version: '17.3.16',
                      update_link:
                        'https://nosso.digitaldoc.com.br/extensions/firefox/digitaldoc_websign-17.3.16-an-fx-windows.xpi',
                    },
                    {
                      version: '17.3.15',
                      update_link:
                        'https://nosso.digitaldoc.com.br/extensions/firefox/digitaldoc_websign-17.3.15-an-fx-windows.xpi',
                    },
                  ],
                },
              },
            },
            beta: {
              extension: '17.3.14',
              native: '17.3.14',
              timestamp: '2017-03-13T20:42:47.230Z',
            },
            updater: {
              todayVersion: logWrapper(
                updaterTodayVersion,
                runtimeConstant.isDebugServicesInternals
              ),
              versionAgeInDays: logWrapper(
                updaterVersionAgeInDays,
                runtimeConstant.isDebugServicesInternals
              ),
              newerVersion: logWrapper(
                updaterNewerVersion,
                runtimeConstant.isDebugServicesInternals
              ),
              latestFirefoxUpdateVersion: logWrapper(
                updaterLatestFirefoxUpdateVersion,
                runtimeConstant.isDebugServicesInternals
              ),
            },
            id2promise: {},
            versionAgeInDays: logWrapper(
              versionAgeInDays,
              runtimeConstant.isDebugServicesInternals
            ),
            getNonce: logWrapper(
              getNonce,
              runtimeConstant.isDebugServicesInternals
            ),
            processMessage: logWrapper(
              processMessage,
              runtimeConstant.isDebugServicesInternals
            ),
            msg2promise: logWrapper(
              msg2promise,
              runtimeConstant.isDebugServicesInternals
            ),
            hasExtension: logWrapper(
              hasExtension,
              runtimeConstant.isDebugServicesInternals
            ),
            getNativeVersion: logWrapper(
              getNativeVersion,
              runtimeConstant.isDebugServicesInternals
            ),
            getCertificate: logWrapper(
              getCertificate,
              runtimeConstant.isDebugServicesInternals
            ),
            sign: logWrapper(sign, runtimeConstant.isDebugServicesInternals),
            firefoxInstall: logWrapper(
              firefoxInstall,
              runtimeConstant.isDebugServicesInternals
            ),
            getInstallerURL: logWrapper(
              getInstallerURL,
              runtimeConstant.isDebugServicesInternals
            ),
            validateAndInstall: logWrapper(
              validateAndInstall,
              runtimeConstant.isDebugServicesInternals
            ),
          };

          window.addEventListener('message', factory.processMessage);

          return factory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
